<template>
        <div class="updates-container mx-auto col-12 ">
            <div class="updates-container-text py-3 updates-text text-center mt-2">
                <svg-icon name="virus" class="mr-3" width="34" height="auto"></svg-icon>
                <a href="https://www.transport.gov.scot/coronavirus-covid-19/" target="_blank">See updates and advice on the impact of COVID-19 on your travel choices</a>
            </div>
        </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
}
</script>
<style>
.updates-text{
    cursor: pointer;
}
.updates-text a{
    color: white;
}
.updates-text a:hover{
    color: #2B363B;
}
</style>
